import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
import LandingPage from "./components/LandingPage";
import RegisterPage from "./components/RegisterPage";
import WelcomePage from "./components/WelcomePage";
import PrivacyPage from "./components/PrivacyPage";
import TermsPage from "./components/TermsPage";
import JobsPage from "./components/JobsPage";
import JobDetailPage from "./components/JobDetailPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Main Dashboard/Home after registration
const Dashboard = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div>
      <header className="App-header">
        <a
          className="App-link"
          href="https://emergent.sh"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4" alt="Logo" />
        </a>
        <p className="mt-5">Welkom bij TalentSwipe!</p>
      </header>
    </div>
  );
};

// Landing Flow Component
const LandingFlow = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState('landing'); // 'landing', 'register', 'welcome'
  const [userEmail, setUserEmail] = useState('');

  const handleRegisterClick = () => {
    setStep('register');
  };

  const handleRegistrationComplete = (email) => {
    setUserEmail(email);
    // Store in localStorage for session persistence
    localStorage.setItem('earlyAccessEmail', email);
    localStorage.setItem('userRole', 'candidate');
    // Go to welcome screen (final screen)
    setStep('welcome');
  };

  if (step === 'welcome') {
    return <WelcomePage />;
  }

  if (step === 'register') {
    return <RegisterPage onComplete={handleRegistrationComplete} onBack={() => setStep('landing')} />;
  }

  return <LandingPage onSuccess={handleRegisterClick} />;
};

// Protected Route - checks if user has completed registration
const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const email = localStorage.getItem('earlyAccessEmail');

  useEffect(() => {
    if (!email) {
      navigate('/');
    }
  }, [email, navigate]);

  if (!email) {
    return null;
  }

  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingFlow />} />
          <Route path="/jobs" element={<JobsPage />} />
          <Route path="/jobs/:slug" element={<JobDetailPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
